import { useEffect, useState } from "react";
import { Pencil, Plus, Trash2, UserRound, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, ROLE_LABELS } from "../api";
import { useAuth } from "../auth";
import { myCompaniesOf } from "../components/CompanyScopeBar";

const EMPTY = { email: "", name: "", role: "project_manager", password: "", project_ids: [], companies: [] };

export default function Users() {
  const { user: me } = useAuth();
  const myCompanies = myCompaniesOf(me);
  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [form, setForm] = useState(null); // null: kapalı, {id?...}: form

  const load = () => api.get("/users").then((r) => setUsers(r.data)).catch(() => toast.error("Kullanıcılar yüklenemedi"));
  useEffect(() => { load(); api.get("/projects").then((r) => setProjects(r.data)).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (form.id) await api.put(`/users/${form.id}`, form); else await api.post("/users", form);
      toast.success(form.id ? "Kullanıcı güncellendi" : "Kullanıcı oluşturuldu");
      setForm(null); load();
    } catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (u) => {
    if (!window.confirm(`${u.email} silinsin mi?`)) return;
    try { await api.delete(`/users/${u.id}`); toast.success("Kullanıcı silindi"); load(); } catch (err) { toast.error(errMsg(err)); }
  };
  const toggleProject = (pid) => setForm((f) => ({ ...f, project_ids: f.project_ids.includes(pid) ? f.project_ids.filter((x) => x !== pid) : [...f.project_ids, pid] }));
  const toggleCompany = (c) => setForm((f) => ({ ...f, companies: (f.companies || []).includes(c) ? f.companies.filter((x) => x !== c) : [...(f.companies || []), c] }));

  return (
    <main className="content" data-testid="page-users">
      <div className="page-head">
        <div>
          <span className="section-kicker">YETKİ MATRİSİ</span>
          <h1>Kullanıcılar ({users.length})</h1>
          <p>Ana Yönetici kullanıcıları yönetir. Yönetici tüm veriyi; Proje Yöneticisi yalnızca sorumlusu olduğu/atandığı projeleri; Finans tüm ödeme ve raporları görür.</p>
        </div>
        <button className="new-btn" onClick={() => setForm({ ...EMPTY })} data-testid="add-user-button"><Plus size={17} /> Yeni Kullanıcı</button>
      </div>

      <section className="panel role-matrix" data-testid="role-matrix">
        <div className="table-row table-head role-row"><span>YETKİ</span><span>YÖNETİCİ</span><span>PROJE YÖNETİCİSİ</span><span>FİNANS</span></div>
        {[["Proje / iş kalemi oluştur-düzenle", "✓", "Kendi projeleri", "—"], ["Ödeme kaydı", "✓", "Kendi projeleri", "✓"], ["Kâr/zarar & PDF rapor", "✓", "Kendi projeleri", "✓"], ["Kur yönetimi", "✓", "Görüntüleme", "✓"], ["Excel içe aktarma", "✓", "—", "—"]].map((r) => (
          <div className="table-row role-row" key={r[0]}><b>{r[0]}</b>{r.slice(1).map((c, i) => <span key={i} className={c === "✓" ? "margin" : ""}>{c}</span>)}</div>
        ))}
      </section>

      <section className="panel">
        <div className="project-table" data-testid="users-table">
          <div className="table-row table-head user-row"><span>KULLANICI</span><span>ROL</span><span>ATANAN PROJE</span><span>SON GİRİŞ</span><span></span></div>
          {users.map((u) => (
            <div className="table-row user-row" key={u.id} data-testid={`user-row-${u.email}`}>
              <div className="project-name"><div className="project-badge badge-1"><UserRound size={13} /></div><div><b>{u.name}</b><small>{u.email}</small></div></div>
              <span>{u.is_super_admin ? <em className="status status-red">Ana Yönetici</em> : <em className={`status ${u.role === "admin" ? "status-amber" : u.role === "finance" ? "status-green" : "status-blue"}`}>{ROLE_LABELS[u.role]}</em>}</span>
              <span className="mono-small">{u.role === "project_manager" ? `${(u.project_ids || []).length} proje + sorumlu olduğu` : "Tümü"}</span>
              <span className="mono-small">{u.last_login ? u.last_login.slice(0, 10) : "—"}</span>
              <div className="row-actions">
                <button className="row-action" onClick={() => setForm({ ...u, password: "", project_ids: u.project_ids || [], companies: u.companies || [] })} data-testid={`edit-user-${u.email}`}><Pencil size={13} /></button>
                {u.id !== me.id && !u.is_super_admin && <button className="row-action danger" onClick={() => remove(u)} data-testid={`delete-user-${u.email}`}><Trash2 size={13} /></button>}
              </div>
            </div>
          ))}
        </div>
      </section>

      {form && (
        <div className="modal-backdrop" onClick={() => setForm(null)}>
          <form className="modal" onClick={(e) => e.stopPropagation()} onSubmit={submit} data-testid="user-form-modal">
            <div className="modal-head">
              <div><span className="eyebrow">{form.id ? "DÜZENLE" : "YENİ KULLANICI"}</span><h2>{form.id ? form.name : "Kullanıcı oluştur"}</h2></div>
              <button type="button" onClick={() => setForm(null)} data-testid="user-modal-close"><X size={18} /></button>
            </div>
            <div className="form-grid">
              <label>Ad Soyad<input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="user-name-input" /></label>
              <label>E-posta<input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="user-email-input" /></label>
            </div>
            <div className="form-grid">
              <label>Rol
                <select value={form.is_super_admin ? "admin" : form.role} disabled={form.is_super_admin} onChange={(e) => setForm({ ...form, role: e.target.value })} data-testid="user-role-select">
                  {Object.entries(ROLE_LABELS).filter(([k]) => k !== "super_admin" && k !== "calisan").map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
                {form.is_super_admin && <small className="muted">Ana Yönetici rolü değiştirilemez</small>}
                {!form.is_super_admin && <small className="muted">Çalışan (personel) hesapları İzin &amp; Takvim → Çalışanlar → “Çalışan Ekle” üzerinden açılır.</small>}
              </label>
              <label>{form.id ? "Yeni şifre (boş bırakılırsa değişmez)" : "Şifre"}
                <input type="password" required={!form.id} minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="user-password-input" />
              </label>
            </div>
            <div className="assign-box" data-testid="user-company-assign">
              <span className="eyebrow">ERİŞEBİLECEĞİ ŞİRKETLER · boş bırakılırsa tüm şirketleri görür</span>
              <div className="assign-list companies">
                {myCompanies.map((c) => (
                  <label key={c} className="check-label">
                    <input type="checkbox" checked={(form.companies || []).includes(c)} onChange={() => toggleCompany(c)} data-testid={`user-company-${c === "REEN Enerji" ? "enerji" : "mt"}`} /> {c}
                  </label>
                ))}
              </div>
            </div>
            {form.role === "project_manager" && (
              <div className="assign-box" data-testid="user-project-assign">
                <span className="eyebrow">ATANAN PROJELER · sorumlusu olduğu projeler ({form.name || "ad"}) otomatik görünür</span>
                <div className="assign-list">
                  {projects.map((p) => (
                    <label key={p.id} className="check-label">
                      <input type="checkbox" checked={form.project_ids.includes(p.id)} onChange={() => toggleProject(p.id)} /> {p.name} <small>· {p.employer_short}</small>
                    </label>
                  ))}
                </div>
              </div>
            )}
            <button className="new-btn full" data-testid="save-user-button"><Plus size={16} /> {form.id ? "Güncelle" : "Oluştur"}</button>
          </form>
        </div>
      )}
    </main>
  );
}
